export class Incoterm {
    id:number;
    code: string;
    name: string;
}
